import { groupIndustryNavigation, workAreaCategoryLabel } from '@vivaporta/work-areas';
import { html } from 'lit';
import type { LandingLocale, LandingNavItem } from '../../shared/content/landingContentTypes.js';
import {
  editorNodeClass,
  editorNodeClick,
  editorNodePointerDown,
  editorNodeStyle,
  type LandingEditorRenderOptions,
} from '../editor/landingEditorRender.js';
import { navigationIndustryIcon } from './navigationIndustryIcon.js';

type IndustryItem = LandingNavItem & { text?: string };
interface Options {
  items: IndustryItem[];
  locale: LandingLocale;
  editor?: LandingEditorRenderOptions;
  hrefFor: (href: string) => string;
  descriptionFor: (item: IndustryItem) => string;
  onLink: (event: MouseEvent, href: string) => unknown;
}
export const industryMegaMenu = (options: Options) => {
  const { editor } = options;
  const grouped = groupIndustryNavigation(options.items);
  const link = (item: IndustryItem, index: number, parent = false) => {
    const id = `navigation.industry.${index}.label`,
      description = options.descriptionFor(item);
    return html`<a
      class=${parent ? 'vp-industry-category-link' : 'vp-industry-entry'}
      href=${options.hrefFor(item.href)}
      title=${description}
      @click=${(event: MouseEvent) => options.onLink(event, item.href)}
    >
      <span class="vp-industry-menu-icon" aria-hidden="true"
        ><span class=${navigationIndustryIcon(item.href)}></span
      ></span>
      <strong
        class=${editorNodeClass(editor, id)}
        style=${editorNodeStyle(editor, id)}
        @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, id, event)}
        @click=${(event: MouseEvent) => editorNodeClick(editor, id, event)}
        >${item.label}</strong
      >
      <span class="vp-industry-entry-description">${description}</span>
    </a>`;
  };
  return html`<div class="vp-dropdown-list vp-industry-groups">
    ${grouped.groups
      .filter(group => group.parent || group.children.length)
      .map(
        group =>
          html` <section class="vp-industry-menu-group" data-industry-category=${group.category}>
            <div class="vp-industry-menu-group-heading">
              ${group.parent
                ? link(group.parent.item, group.parent.index, true)
                : html`<strong>${workAreaCategoryLabel(group.category, options.locale)}</strong>`}
            </div>
            <div class="vp-industry-group-links">${group.children.map(({ item, index }) => link(item, index))}</div>
          </section>`,
      )}
    ${grouped.ungrouped.length
      ? html`<div class="vp-industry-menu-ungrouped">
          ${grouped.ungrouped.map(({ item, index }) => link(item, index))}
        </div>`
      : ''}
  </div>`;
};
